import React, { useEffect, useState } from "react";
import { Badge, Calendar, Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { convertUTCDate } from "../../../../../../utils/convertionFunc";
import {
  fetchRpmPatCalenderActivity,
  setSelectedRpmPatient,
} from "../../../../../../Redux/actions/rpmActions";
import dayjs from "dayjs";

function Calendarview() {
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
  const { selectedRpmPatient, rpmCalenderActivity } = useSelector(
    (state) => state.rpm
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (!selectedRpmPatient) {
      const rpmPatientJson = sessionStorage.getItem("rpmPatient");
      const rpmPatientObject = rpmPatientJson
        ? JSON.parse(rpmPatientJson)
        : null;
      if (rpmPatientObject) {
        dispatch(setSelectedRpmPatient(rpmPatientObject));
      }
    }
  }, [dispatch, selectedRpmPatient]);

  useEffect(() => {
    if (!selectedRpmPatient?.patientId) return;

    const fromDate = dayjs(new Date(selectedYear, selectedMonth - 1, 1)).format(
      "MM/DD/YYYY"
    );
    const toDate = dayjs(new Date(selectedYear, selectedMonth, 0)).format(
      "MM/DD/YYYY"
    );

    const payload = {
      patientId: selectedRpmPatient.patientId,
      rpmApplicable: "Y",
      fromDate,
      toDate,
    };

    dispatch(fetchRpmPatCalenderActivity(payload));
  }, [dispatch, selectedRpmPatient, selectedYear, selectedMonth]);

  const getEventTags = (entry) => {
    const tags = [];

    if (entry.vitalsEntered === "Y") {
      tags.push({ type: "Vitals", color: "green" });
    }
    if (entry.medicationEntered === "Y") {
      tags.push({ type: "Medication", color: "blue" });
    }
    if (entry.taskEntered === "Y") {
      tags.push({ type: "Task", color: "orange" });
    }

    return tags;
  };

  // Render events on each date
  const dateCellRender = (value) => {
    const formatted = value.format("YYYY-MM-DD");
    const matchedEntry = rpmCalenderActivity.find(
      (item) => item.date === formatted
    );

    if (!matchedEntry) return null;

    const tags = getEventTags(matchedEntry);

    return (
      <ul className="events">
        {tags.map((tag, index) => (
          <li key={index}>
            <Tooltip title={tag.type}>
              <Badge color={tag.color} text={tag.type} />
            </Tooltip>
          </li>
        ))}
      </ul>
    );
  };

  // Detect panel change (month/year)
  const handlePanelChange = (value, mode) => {
    const newMonth = value.month() + 1;
    const newYear = value.year();

    if (newMonth !== selectedMonth || newYear !== selectedYear) {
      setSelectedMonth(newMonth);
      setSelectedYear(newYear);
    }
  };

  return (
    <div className="p-4 bg-white rounded shadow">
      <Calendar
        dateCellRender={dateCellRender}
        onPanelChange={handlePanelChange}
      />
    </div>
  );
}

export default Calendarview;
